import type { DirectoryPerson } from "@sales-ops-amplify/shared";

/** URL segment for company column links — never a name slug. */
export function personCompanyLinkId(
  person: DirectoryPerson,
  base: "/companies" | "/user/accounts",
): string | undefined {
  if (base === "/user/accounts") {
    return person.accountId?.trim() || undefined;
  }
  const org = person.organization;
  return (
    org?.companyId?.trim() ||
    person.companyId?.trim() ||
    org?.apolloOrgId?.trim() ||
    undefined
  );
}

export function personCompanyLinkPath(
  person: DirectoryPerson,
  base: "/companies" | "/user/accounts",
): string | undefined {
  const id = personCompanyLinkId(person, base);
  return id ? `${base}/${encodeURIComponent(id)}` : undefined;
}

export function personOrganizationName(person: DirectoryPerson): string {
  return person.organization?.name?.trim() || "—";
}
